type Occassion = {
  id: string;
  title: string;
};

export const getOccassionLabel = (
  occassions: Occassion[] | undefined,
  occassion: string | null | undefined,
) =>
  occassions?.find((item) => item.id === occassion)?.title ?? occassion ?? '';
